import React from "react";

import DprReport from "./DailyReport/DprReport";
import MaterialConsumptionReport from "./DailyReport/MaterialConsumptionReport";
import DailyMaterialReceiptReport from "./DailyReport/DailyMaterialReceiptReport";
import ManPowerStatementReport from "./DailyReport/ManPowerStatementReport";
import DailyTotalWorkforceReport from "./DailyReport/DailyTotalWorkforceReport";
import DailyProgressDprReport from "./DailyReport/DailyProgressDprReport";
import DRSNotesReport from "./FinalReport/DRSNotesReport";
import LookAheadProgressReport from "./DailyReport/LookAheadProgressReport";
import StatementEquipmentLatestPlantInReport from "./DailyReport/StatementEquipmentLatestPlantInReport";
import StatementEquipmentLatestPlantOutReport from "./DailyReport/StatementEquipmentLatestPlantOutReport";
import MaterialDisposedSummary from "./DailyReport/MaterialDisposedSummary";
import SiteCashPaymentsDashboardCard from "./DailyReport/SiteCashPaymentsReport";
import EquipmentStatementReport from "./DailyReport/EquipmentStatementReport";
import OverallScheduleStatus from "./FinalReport/OverallScheduleStatus";

interface Props {
  projectId: number;
}

export default function ProjectDashboard({ projectId }: Props) {
  return (
    <div className="bg-slate-50 min-h-screen p-4 md:p-6">

      {/* ===== MAIN DASHBOARD GRID ===== */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">

        {/* ================= LEFT SIDE (SUMMARY ONLY) ================= */}
        <div className="xl:col-span-4 space-y-6">
          <DprReport projectId={projectId} />
           <OverallScheduleStatus projectId={projectId} />
           
          
        </div>

        {/* ================= RIGHT SIDE ================= */}
        <div className="xl:col-span-8 space-y-6">

          {/* ===== KPI SECTION ===== */}
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
            <DailyMaterialReceiptReport projectId={projectId} />
            <MaterialConsumptionReport projectId={projectId} />
            <ManPowerStatementReport projectId={projectId} />
            <DailyTotalWorkforceReport projectId={projectId} />
            <StatementEquipmentLatestPlantInReport />
            <StatementEquipmentLatestPlantOutReport />
            <MaterialDisposedSummary />
            <SiteCashPaymentsDashboardCard projectId={projectId} />
          </div>

          {/* ===== OPERATIONAL MONITORING SECTION ===== */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

            {/* HELD UP WORKS */}
            <div className="space-y-6">
              <DailyProgressDprReport projectId={projectId} />
                <EquipmentStatementReport /> {/* ✅ Added under DPR */}
            </div>

            {/* WEEKLY STATUS / LOOK AHEAD */}
            <div>
              <LookAheadProgressReport />
            </div>

            {/* STATEMENT NOTES */}
            <div>
              <DRSNotesReport projectId={projectId} />
              
            </div>

          </div>

        </div>

      </div>
    </div>
  );
}